import { Modal } from 'flowbite-react';
import { createWork, getWorkById } from '../../../common/services/work.api';
import { useToastContext } from '../../../common/components/ui/toast/toast.context';
import { Formik } from 'formik';
import { emptyWork } from '../../../types/work.type';
import * as Yup from 'yup';
import { Form } from 'react-router-dom';
import InputFormik from '../../../common/components/form/InputFormik';
import ButtonWithLoader from '../../../common/components/ui/loading/ButtonLoading';
import ComboBoxFormik from '../../../common/components/form/ComboBoxFormik';
import { useEffect, useState } from 'react';
import { getAllCategories } from '../../../common/services/category.api';
import { ICategory } from '../../../types/category.types';
import { maskCurrency } from '../../../common/helpers/mask.helpers';
import { ImCheckboxChecked, ImCheckboxUnchecked } from 'react-icons/im';
import { currencyToNumber } from '../../../common/helpers/currency-to-number';

type Props = {
  onClose?: () => void
  onSave: (vehicleId: string) => void
  id: string;
}

const validationSchema = Yup.object().shape({
  name: Yup.string(),
  category: Yup.string(),
  preventive: Yup.bool(),
  corrective: Yup.bool(),
  misuse: Yup.bool()
});

export default function ModalWork(props: Props) {

  const { notifySuccess, notifyError } = useToastContext()
  const handleCloseModal = () => { props.onClose && props.onClose() }

  const [categories, setCategories] = useState<ICategory[]>([]);
  const [initialValues, setInitialValues] = useState(emptyWork());
  const [typeProduct, _setTypeProduct] = useState({
    preventive: false,
    corrective: false,
    misuse: false
  });

  const setTypeProduct = (value) => {
    _setTypeProduct({ ...typeProduct, ...value });
  }

  async function handleSubmit(data) {

    delete data.__v;
    const result = await createWork({
      ...data,
      corrective: typeProduct.corrective,
      misuse: typeProduct.misuse,
      preventive: typeProduct.preventive,
      sellPrice: currencyToNumber(data.sellPrice) || data.sellPrice,
      updatedAt: props.id ? new Date() : undefined
    })

    if (!result.ok) {
      notifyError(result.message as string)
      return;
    }

    props.onSave((result.data as { _id: string })?._id)
    notifySuccess("Criado Serviço com Sucesso");
  }

  useEffect(() => {

    async function loadWork() {
      if (!props.id) {
        return;
      }

      const result = await getWorkById(props.id);
      const data = result.data;
      setInitialValues(data);
      _setTypeProduct({ corrective: data.corrective, misuse: data.misuse, preventive: data.preventive })
    }

    async function loadCategories() {
      const result = await getAllCategories();
      setCategories(result.data);
    }

    loadWork();
    loadCategories();
  }, [props.id]);

  return (
    <Modal
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black'>
        <h2 className='text-black'>{'Novo Serviço'}</h2>
      </Modal.Header>
      <Modal.Body className='text-black' style={{ minHeight: 'calc(50vh - 200px)', height: 'calc(50vh - 200px)' }}>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          validationSchema={validationSchema}
        >
          {({ isSubmitting, handleSubmit }) => {
            return (
              <Form>
                <InputFormik
                  label='Descrição:'
                  name='name'
                  className='w-full mb-2'
                  required={true}
                  defaultValue={initialValues.name}
                />
                <InputFormik
                  label='Preço de venda:'
                  name='sellPrice'
                  className='w-full mb-2'
                  mask={maskCurrency}
                  required={true}
                  defaultValue={initialValues.sellPrice}
                />
                <ComboBoxFormik
                  label='Categoria'
                  name='category'
                  options={[{ label: initialValues.category, value: initialValues.category }, ...categories.map(category => ({ label: category.name, value: category.name })).filter(category => category.label.match(/serviço/gi)).filter(category => category.value != initialValues.category)]}
                  className='w-full mb-2'
                  required={true}
                />
                <div className="relative color flex items-center">
                  <label htmlFor={`preventive`} className="block text-sm font-medium text-gray-600">
                    {typeProduct.preventive ? (
                      <div className="flex gap-2 items-center justify-start text-greenPrimary">
                        <ImCheckboxChecked />
                        <span>Preventivo ?</span>
                      </div>
                    ) : (
                      <div className="flex gap-2 items-center justify-start">
                        <ImCheckboxUnchecked />
                        <span>Preventivo ?</span>
                      </div>
                    )}
                    <input
                      id="preventive"
                      name="preventive"
                      type="checkbox"
                      checked={typeProduct.preventive}
                      onChange={() => {
                        const newValue = !typeProduct.preventive;
                        setTypeProduct({ preventive: newValue });
                      }}
                      className="border p-2 rounded w-full absolute opacity-0"
                    />
                  </label>

                  <label htmlFor={`corrective`} className="block text-sm ml-2 font-medium text-gray-600">
                    {typeProduct.corrective ? (
                      <div className="flex gap-2 items-center justify-start text-greenPrimary">
                        <ImCheckboxChecked />
                        <span>Corretivo ?</span>
                      </div>
                    ) : (
                      <div className="flex gap-2 items-center justify-start">
                        <ImCheckboxUnchecked />
                        <span>Corretivo ?</span>
                      </div>
                    )}
                    <input
                      id="corrective"
                      name="corrective"
                      type="checkbox"
                      checked={typeProduct.corrective}
                      onChange={() => {
                        const newValue = !typeProduct.corrective;
                        setTypeProduct({ corrective: newValue });
                      }}
                      className="border p-2 rounded w-full absolute opacity-0"
                    />
                  </label>

                  <label htmlFor={`misuse`} className="block text-sm ml-2 font-medium text-gray-600">
                    {typeProduct.misuse ? (
                      <div className="flex gap-2 items-center justify-start text-greenPrimary">
                        <ImCheckboxChecked />
                        <span>Mau Uso ?</span>
                      </div>
                    ) : (
                      <div className="flex gap-2 items-center justify-start">
                        <ImCheckboxUnchecked />
                        <span>Mau Uso ?</span>
                      </div>
                    )}
                    <input
                      id="misuse"
                      name="misuse"
                      type="checkbox"
                      checked={typeProduct.misuse}
                      onChange={() => {
                        const newValue = !typeProduct.misuse;
                        setTypeProduct({ misuse: newValue });
                      }}
                      className="border p-2 rounded w-full absolute opacity-0"
                    />
                  </label>

                </div>
                <div className="flex justify-end mt-8">
                  <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}> Enviar </ButtonWithLoader>
                </div>
              </Form>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
